import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HttpLink } from "apollo-link-http";
import { ApolloClient, InMemoryCache, ApolloProvider } from "@apollo/client";
const API =
  "https://api-eu-central-1.graphcms.com/v2/cku328sr45zu601xm6lzicf76/master";

const client = new ApolloClient({
  uri: API,
  cache: new InMemoryCache(),
});
ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
